import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionDepartmentUpdateInput } from '../generated/globalTypes';
import { updateSubscriptionDepartmentMutation, updateSubscriptionDepartmentMutationVariables } from '../generated/updateSubscriptionDepartmentMutation';
import { subscriptionDepartmentFieldsFragment } from '../models/SubscriptionDepartment';

/**
 * Get a callback to update a SubscriptionDepartment in the store.
 */
export function useUpdateSubscriptionDepartmentCallback(): [(id: string, model: SubscriptionDepartmentUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSubscriptionDepartmentMutation, updateSubscriptionDepartmentMutationVariables>(
        gql`
            mutation updateSubscriptionDepartmentMutation ($model: SubscriptionDepartmentUpdateInput!) {
                updateSubscriptionDepartment(model: $model) {
                    ...subscriptionDepartmentFields
                }
            }

            ${subscriptionDepartmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SubscriptionDepartmentUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
